module.exports = __webpack_public_path__ + "img/BFT-alt.b5d8a69b.svg";